<template>
  <div>
    <p>&nbsp;</p>
  </div>
</template>

<script>
    export default {
        name: "EmptySideNav"
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/EmptySideNav.vue